









import { defineComponent } from '@nuxtjs/composition-api';
import { BaseImage, BaseLink } from '@shared/ui';

export default defineComponent({
  name: 'SearchResultsBrandCard',
  components: {
    BaseImage,
    BaseLink,
  },
  props: {
    imageSrc: {
      type: String,
      default: '',
    },
    imageAlt: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
  },
});
